import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Toolbar' })({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    }
});
